export default "__VITE_ASSET__BxcU2PdP__"